// extracted by mini-css-extract-plugin
module.exports = {"status":"Status_status__1SEwG"};